import { auth } from './utils/auth';
import { initializeGloballyExposedAuthHelpers } from './auth/auth-utils';
import { syncAuthState } from './redux/slice/authSlice';
import { PropsWithChildren, useEffect } from 'react';
// import { RootState, useAppDispatch, useAppSelector } from '@app/redux/store';
import { useAppDispatch } from '@app/redux/store';
import { useAuth0 } from '@equipmentshare/auth0-react';

function InitAuth({ children }: PropsWithChildren) {
  // const authState = useAppSelector((state: RootState) => state.auth);
  const auth0 = useAuth0();
  const dispatch = useAppDispatch();

  const { isAuthenticated, isLoading } = auth0;

  useEffect(() => {
    auth.setAuth0(auth0);
  }, [auth0]);

  useEffect(() => {
    if (isLoading) {
      return;
    }
    dispatch(syncAuthState({ status: isAuthenticated }));
  }, [dispatch, isAuthenticated, isLoading]);

  useEffect(() => {
    initializeGloballyExposedAuthHelpers();
  }, []);

  return <>{children}</>;
}

export default InitAuth;
